import RoleAccessIndex from "@/components/billing_mapping/role_access/RoleAccessIndex.vue";
import RoleAccessDetail from "@/components/billing_mapping/role_access/RoleAccessDetail.vue";
import RoleAccessEdit from "@/components/billing_mapping/role_access/RoleAccessEdit.vue";
import RoleAccessCreate from "@/components/billing_mapping/role_access/RoleAccessAdd.vue";

let RoleAccessRoute = [
  {
    path: "/",
    meta: {
      title: "Role Access Billing Mapping",
    },
    name: "RoleAccessIndex",
    component: RoleAccessIndex,
  },
  {
    path: "detail/:mapping_id",
    meta: {
      title: "Detail Role Access Billing Mapping",
    },
    name: "RoleAccessDetail",
    component: RoleAccessDetail,
  },
  {
    path: "edit/:mapping_id",
    meta: {
      title: "Edit Role Access Billing Mapping",
    },
    name: "RoleAccessEdit",
    component: RoleAccessEdit,
  },
  {
    path: "create",
    meta: {
      title: "Create Role Access Billing Mapping",
    },
    name: "RoleAccessCreate",
    component: RoleAccessCreate,
  },
];

export default RoleAccessRoute;
